
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';

const Register = () => {
    const [registered, setRegistered] = useState(false)
    const [register, setRegister] = useState({ firstname: '', lastname: '', username: '', password: '', email: '', mobile: '',language:1, error: '' })
    const [formerror, setFormError] = useState('')
    const [languages, setlanguages] = useState([])

    const changeData = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setRegister(prev => {
            return {
                ...prev,
                [name]: value
            }
        })
        if(name === 'email'){

            setRegister(prev => {
                return {
                    ...prev,
                    username: value.split('@')[0]
                }
            })  
        }
    }

    const removeError = (e) => {
        setFormError('')
    }

    const validate = () => {
        if(!register.firstname) {
            setFormError('Please type first name.')
            return false;            
        }
        if (!(/^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(register.email)) {
            setFormError('Please type a valid email address')
            return false;
        }
        if (!/((\+*)((0[ -]+)*|(91 )*)(\d{12}|\d{10}))|\d{5}([- ]*)\d{6}/.test(register.mobile))
        {
            setFormError('Please type a valid mobile number')
            return false;
        }
        if (!/^[a-zA-Z0-9\\.|-|_]+$/.test(register.username)) {
            setFormError('Please type a valid login id')
            return false;
        }
        if(!register.password) {
            setFormError('Please type password.')
            return false;    
        }
        if(!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(register.password)){
            setFormError('Password should have minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character')
            return false;    
        }
        return true;
    }
    const getSignUp = async (e) => {
        e.preventDefault();
        if (validate()) {
            try {
                await axios.post(
                    localStorage.getItem('basurl') + '/register', register
                ).then(response => {
                    setRegistered(true)
                }).catch(err => {
                   setFormError(err.response.data.message)
                });
            } catch (err) {
                setFormError(err.message)
            }
        }
    }

    const getLanguage = async () => {
        try {
            await axios.get(
                localStorage.getItem('basurl') + '/languages',
            ).then(response => {
                setlanguages(response.data)
            }).catch(err => {
               setFormError(err.response.data.message)
            });
        } catch (err) {
            setFormError(err.message)
        }
    }

    useEffect(()=>{
        getLanguage();
    },[])

    return (
        <>
            <div className="d-flex align-items-center justify-content-center bg-br-primary ht-100v">
                <div className="login-wrapper wd-300 wd-xs-350 pd-25 pd-xs-40 bg-white rounded shadow-base">
                    <div className="signin-logo tx-center tx-28 tx-bold tx-inverse"><span className="tx-normal">[TV9 MOJO]</span></div>
                    <div className="tx-center mg-b-20">Mobile Friendly Solution</div>
                    {registered === false ?
                        <>
                            <span className="text-danger">{formerror}</span>
                            <form method="post" onSubmit={getSignUp}>
                                <div className="form-group input-group">
                                    <span className="input-group-addon"><i className="icon ion-man tx-16 lh-0 op-6"></i></span>
                                    <input id="signup-firstname" type="text" name="firstname" value={register.firstname} onFocus={removeError} onChange={changeData} placeholder="Please enter your first name" className="form-control" />
                                </div>
                                <div className="form-group input-group">
                                    <span className="input-group-addon"><i className="icon ion-man tx-16 lh-0 op-6"></i></span>
                                    <input id="signup-lastname" type="text" name="lastname" onFocus={removeError} onChange={changeData} placeholder="Please enter your last name" className="form-control" value={register.lastname} />
                                </div>
                                <div className="form-group input-group">
                                    <span className="input-group-addon"><i className="icon ion-email tx-16 lh-0 op-6"></i></span>
                                    <input id="signup-email" type="email" name="email" onFocus={removeError} onChange={changeData} placeholder="Please enter your email address" className="form-control" value={register.email} />
                                </div>
                                <div className="form-group input-group">
                                    <span className="input-group-addon"><i className="icon ion-iphone tx-16 lh-0 op-6"></i></span>
                                    <input id="signup-mobile" type="phone" name="mobile" onFocus={removeError} onChange={changeData} placeholder="Please enter your mobile number" className="form-control" maxLength={10} value={register.mobile} />
                                </div>
                                <div className="form-group input-group">
                                    <span className="input-group-addon"><i className="icon ion-person tx-16 lh-0 op-6"></i></span>
                                    <input id="signup-username" type="text" name="username" readOnly={true} onFocus={removeError} onChange={changeData} placeholder="Please enter your login id" className="form-control" value={register.username} />
                                </div>
                                <div className="form-group input-group">
                                    <span className="input-group-addon"><i className="icon ion-key tx-16 lh-0 op-6"></i></span>
                                    <input id="signup-password" type="password" name="password" onFocus={removeError} onChange={changeData} placeholder="Please enter your password" className="form-control" value={register.password} />
                                </div>
                                <div className="form-group input-group">
                                    <span className="input-group-addon"><i className="fa fa-language tx-16 lh-0 op-6"></i></span>
                                    <select id="signup-language" name="language" onFocus={removeError} onChange={changeData} placeholder="Please choose your language" className="form-control" value={register.language}>
                                        {languages.map(lang=>(
                                            <option key={`lang`+lang.id} value={lang.id}>{lang.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group input-groupter">
                                    <NavLink className="tx-info tx-16" to="/login">
                                        Go Back
                                    </NavLink> &nbsp;&nbsp;
                                    <button type="submit" className="btn btn-success pull-right">SignUp</button>
                                </div>
                            </form>
                        </>
                        :
                        <div>
                            <p className="tx-14 tx-bold">
                                Thank you for registering with us. An account activation link has been sent on your registered email address. Please click on account activation link to actiavte your account.
                            </p>
                            <NavLink to="/login" className="btn btn-secondary pull-right">Go Back</NavLink>
                        </div>
                    }
                </div>
            </div>
        </>
    )
}
export default Register;